import cookies from '../../plugins/cookies';

class BetaPopup {
	constructor () {}
	init ($root = document) {
		this.BetaPopupButton = document.querySelector('[data-action=popup_beta]');
		if (cookies.getCookie("netia_beta") !== "showed" && this.BetaPopupButton) {
			this.BetaPopupButton.click();
			cookies.setCookie("netia_beta", "showed", 365);
		}
	}
}
const betaPopup = new BetaPopup();
export { betaPopup };
